/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UpgradeRuleByDeviceTypeResponse,
    UpgradeRuleByDeviceTypeResponseFromJSON,
    UpgradeRuleByDeviceTypeResponseFromJSONTyped,
    UpgradeRuleByDeviceTypeResponseToJSON,
} from './UpgradeRuleByDeviceTypeResponse';

/**
 * 
 * @export
 * @interface UpgradeRulesByDeviceTypeResponse
 */
export interface UpgradeRulesByDeviceTypeResponse {
    /**
     * 
     * @type {Array<UpgradeRuleByDeviceTypeResponse>}
     * @memberof UpgradeRulesByDeviceTypeResponse
     */
    upgradeRules?: Array<UpgradeRuleByDeviceTypeResponse>;
    /**
     * 
     * @type {number}
     * @memberof UpgradeRulesByDeviceTypeResponse
     */
    count?: number;
}

export function UpgradeRulesByDeviceTypeResponseFromJSON(json: any): UpgradeRulesByDeviceTypeResponse {
    return UpgradeRulesByDeviceTypeResponseFromJSONTyped(json, false);
}

export function UpgradeRulesByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeRulesByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'upgradeRules': !exists(json, 'upgradeRules') ? undefined : ((json['upgradeRules'] as Array<any>).map(UpgradeRuleByDeviceTypeResponseFromJSON)),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function UpgradeRulesByDeviceTypeResponseToJSON(value?: UpgradeRulesByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upgradeRules': value.upgradeRules === undefined ? undefined : ((value.upgradeRules as Array<any>).map(UpgradeRuleByDeviceTypeResponseToJSON)),
        'count': value.count,
    };
}

